import Component from '@bythepixel/component-loader';

export default class colorSelector extends Component {
  static selector = '[comp-option-selector]'

  #activeClass = 'selected';

  constructor(...args) {
    super(...args);
    this.publishOption = this.$container.getAttribute('publish-option');
    this.eventName = `option-selector:choose-${this.publishOption}`;
    this.swatchEls = this.$container.querySelectorAll('button');

    this.state = {
      selectedOption: this.swatchEls[0],
    };

    this.events();

    // Select first option on load
    this.selectOption(this.swatchEls[0]);
  }

  events() {
    this.$container.addEventListener('click', e => {
      const optionEl = e.target;
      if (!optionEl.dataset[this.publishOption] || optionEl.getAttribute('disabled')) return;

      this.selectOption(optionEl);
    });

    this.swatchEls.forEach(el => {
      el.addEventListener('mouseover', e => {
        const optionEl = e.target;
        this.$publish('option-selector:preview-exterior', optionEl.dataset);
      });
    });

    this.$container.addEventListener('mouseleave', () => {
      this.$publish(this.eventName, this.state.selectedOption.dataset);
    });
  }

  selectOption(optionEl) {
    this.state.selectedOption = optionEl;
    this.$publish(this.eventName, this.state.selectedOption.dataset);

    this.swatchEls.forEach(el => {
      if (el.dataset[this.publishOption] === this.state.selectedOption.dataset[this.publishOption]) {
        this.addSelectedClass(el);
      } else {
        this.removeSelectedClass(el);
      }
    });
  }

  addSelectedClass(el) {
    el.classList.add(this.#activeClass);
    el.setAttribute('disabled', 'disabled');
  }

  removeSelectedClass(el) {
    el.classList.remove(this.#activeClass);
    el.removeAttribute('disabled');
  }
}
